module.exports = __webpack_public_path__ + "files/614c42fc06a8977a3ee520256fda0d45.png";